import { render, staticRenderFns } from "./TrekTable.vue?vue&type=template&id=c82ddbf6&scoped=true&"
import script from "./TrekTable.vue?vue&type=script&lang=js&"
export * from "./TrekTable.vue?vue&type=script&lang=js&"
import style0 from "./TrekTable.vue?vue&type=style&index=0&id=c82ddbf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82ddbf6",
  null
  
)

export default component.exports